export const environment = {
  production: true,
  apiUrl: 'https://powerfto-api.staging.neogov.net/api',
  eidSdkUrl: 'https://accounts.staging.powerdms.net/EnterpriseIdentitySdk',
  topNavBundleUrl: 'https://cdn.neogov.net/products/neogov-top-navbar/staging/bundle/bundle.js',
  aiComponentsBundleUrl: 'https://cdn.neogov.net/products/ai-components/staging/bundle/bundle.js',
  writingAssistantApiUrl: 'https://gateway.staging.neogov.net/v1/writing-assistant',
  powerDMSClientId: 'z5fdQSX0Zj0bh38JezPmMmw7V5t9tczC',
  powerDMSURL: 'https://accounts.staging.powerdms.net',
  powerDMSBASEURL: 'https://staging.powerdms.net',
  powerDMSAudience: 'https://api.staging.powerdms.net',
  powerDMSTenantKey: 'https://accounts.staging.powerdms.net/tnt_key',
  powerDMSFilePickerOrigin: 'https://filepicker.staging.powerdms.net',
  powerDMSFilePickerURL: 'https://filepicker.staging.powerdms.net',
  powerDMSRoute: '',
  powerDMSGraphqlBaseURL: 'https://api.sites.staging.powerdms.net',
  gainSightPXCode: '',
  gainSightEnviromentPrefix: '',
  froalaLicenseKey: 'SDB17hD8C7D6D4C3G3J4c1JWSDBCQJ1ZGDa1F1c1JXDAAOZWJhB3D3C10C5C3B4D4F3G3A3==',
  appDynamics: {
    isEnabled: true,
    configurationScriptPath: 'https://cdn.neogov.net/AppDynamics/unifiedsuite-staging-adrum-config.js',
    scriptPath: 'https://cdn.neogov.net/AppDynamics/adrum-latest-unifiedsuite.js',
    appKey: 'AD-AAB-ABV-SWF'
  },
  authSettings: {
    authServerUrl: 'https://accounts.staging.powerdms.net',
    clientId: 'ftoweb',
    scope: 'openid profile email offline_access',
    ssoEnabled: true
  },
  EIDChangePassword:
    'https://securesignin.staging.powerdms.net/ChangePassword?returnUrl=https://powerfto.staging.neogov.net/eid-appswitch',
  EIDAdminChangePasswordUrl: 'https://accounts.staging.powerdms.net',
  passwordResetAllowedDomains: ['.neogov.net', '.neoed.net'],
  appSwitcher: {
    environment: 'staging',
    productsUrl: 'https://accounts.staging.powerdms.net/connect/userinfo'
  }
};
